"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportNotificationCtrl = void 0;
var ExportNotificationCtrl = /** @class */ (function () {
    function ExportNotificationCtrl(notifications) {
        this.collections = {};
        var notificationsWithErrors = this.getNotificationsWithErrors(notifications || []);
        this.errors = notificationsWithErrors.length > 0;
        if (this.errors) {
            this.notifications = notificationsWithErrors;
        }
        else {
            this.notifications = this.getNotificationsWithWarnings(notifications || []);
        }
    }
    ExportNotificationCtrl.prototype.getNotificationsWithErrors = function (notifications) {
        return notifications.filter(function (notification) { return notification.errors.length > 0; });
    };
    ExportNotificationCtrl.prototype.getNotificationsWithWarnings = function (notifications) {
        return notifications.filter(function (notification) { return notification.warnings.length > 0; });
    };
    ExportNotificationCtrl.prototype.getRevisions = function () {
        return this.notifications.map(function (notification) { return notification.revision; });
    };
    ExportNotificationCtrl.prototype.setCollections = function (collections) {
        this.collections = collections.reduce(function (map, collection) {
            map[collection.revision] = collection;
            return map;
        }, {});
    };
    ExportNotificationCtrl.prototype.getCollection = function (revision) {
        return this.collections[revision];
    };
    ExportNotificationCtrl.prototype.getTitleFieldName = function (revision) {
        return this.getCollection(revision).schema.titleField.displayName;
    };
    return ExportNotificationCtrl;
}());
exports.ExportNotificationCtrl = ExportNotificationCtrl;
//# sourceMappingURL=export.notification.ctrl.js.map